import styled from "@emotion/styled";
import { ThemeStyle } from "assets/scss/common/theme";


export const ShippingAddressWrapper = styled.div`
    background: ${({ theme }: ThemeStyle) => theme.brandPrimaryOpacity.backgroundColor};
    border: 1px solid ${({ theme }: ThemeStyle) => theme.brandPrimaryOpacity.borderColor};
    border-radius: ${({ theme }: ThemeStyle) => theme.borders.radiusPrimary};
    padding: 16px;
    .title {
        color: ${({ theme }: ThemeStyle) => theme.primaryText};
        line-height: 24px;
        font-weight: 500;
        letter-spacing: -0.1px;

        strong {
            font-weight: 600;
        }
    }

    .address {
        span {
            color: ${({ theme }: ThemeStyle) => theme.secondaryTextV1};
            line-height: 20px;
            opacity: 0.64;
            width: 80%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .error-msg {
        color: #B60000;
        font-size: 12px;
    }
`;

export const overflowStyle = {
    width: "100%",
};

export const ShippingAddressContent = styled.div`
  margin-bottom: ${({ theme }: ThemeStyle) => theme.sectionSpacingY};
`;
